import {ClipGroup} from "../../../types/mamTypes";
import {useTheme} from "../../../contexts/theme";
import React, {useEffect, useRef, useState} from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import AspectRatioBox from "../../MamContent/AspectRatioBoxComponent/AspectRatioBox";
import logo from "../../../assets/images/Login/inbriefFullWhiteR.svg";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import {formatLabel} from "../../../utils/utils";
import {Button, IconButton, Paper, Popper, Rating} from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import {Clip, Highlight, SocialClip} from "../../../types/clipTypes";
import EditorPopup from "../../EditorPopup/EditorPopup";
import StyledSnackbar from "../StyledSnackbar/StyledSnackbar";
import {formatUTCDate} from "../../../utils/dateTimeutils";
import ClearIcon from '@mui/icons-material/Clear';
import CustomRating from "../CustomRatingComponent/CustomRatingComponent";
import {useMamInformation} from "../../../contexts/MamInformation";
import {LoadError} from "../../../types/generic";
import ErrorSnackBar from "../ErrorSnackBar/ErrorSnackBar";
import VideoContentTags from "../VideoContentTags/VideoContentTags";
import SocialPublishPopup from "../../SocialPublish/SocialPublishPopup";
import ShareIcon from '@mui/icons-material/Share';
import HighlightType from "../HighlightType/HighlightType";
import LoadingChip from "../LoadingChip/Loading";
import StyledCheckBox from "../StyledCheckbox/StyledCheckBox";


interface CardClipComponentProps {
    groupClip: ClipGroup | any;
    handleVideoPlayerURL: (url: string) => void;
    handleOpenVideoPlayerURL: (open: boolean) => void;
    deleteClip: (idClipGroups: string) => void;
    addGroupClip: (idClipGroups: string) => void;
    isDraggable?: boolean;
    isChecked?: boolean;
    deleteClipDraggable?: (id: string) => void;
    originalVideoContent?: Clip | Highlight
    viewTag?: boolean
    idClipSelectedTemplate?: boolean
    handleCheckTemplate?: (id: string) => void
    mode?: "template" | "asset";
}

const isFootball = process.env.REACT_APP_SPORT === 'football';

const CardClipComponent = ({
                               groupClip,
                               handleOpenVideoPlayerURL,
                               handleVideoPlayerURL,
                               deleteClip,
                               addGroupClip,
                               isDraggable,
                               isChecked,
                               deleteClipDraggable,
                               originalVideoContent,
                               viewTag = true,
                               idClipSelectedTemplate,
                               handleCheckTemplate,
                               mode
                           }: CardClipComponentProps) => {
    const theme = useTheme();

    const visibleFieldGroupClip: string[] = ['competition', 'match', 'match_date', 'created_at','period', 'game_time', 'player', 'matchday', 'videoContentProduced', 'key_moment_type', 'duration', 'team', 'aspect_ratio', 'extraction_schedule'];
    const visibleFieldForDragAndDrop: string[] = ['title', 'competition', 'match', 'key_moment_type', 'aspect_ratio', 'generated_at'];


    const [isVideoPlaying, setIsVideoPlaying] = useState(false);
    const hoverTimeoutRef = useRef<NodeJS.Timeout | null>(null);
    const videoRef = useRef<HTMLVideoElement | null>(null);
    const [isClipDownloading, setIsClipDownloading] = React.useState<string>("NODOWNLOAD");
    const [openPopper, setOpenPopper] = useState(false);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const {setUpdateLoading, updateVideoContentTags} = useMamInformation();

    const [editorClip, setEditorClip] = useState<Clip | undefined>();
    const [editorError, setEditorError] = React.useState<LoadError>({error: false, message: ""});
    const [editorOpen, setEditorOpen] = React.useState<boolean>(false);

    const [publishClip, setPublishClip] = useState<Clip | Highlight | undefined>();
    const [publishOpen, setPublishOpen] = React.useState<boolean>(false);

    const handleMouseEnter = () => {
        hoverTimeoutRef.current = setTimeout(() => {

            setIsVideoPlaying(true);
            if (videoRef.current) {
                videoRef.current.play();
            }
        }, 2000);
    };


    const handlePlayButton = (url: string) => {
        handleVideoPlayerURL(url);
        handleOpenVideoPlayerURL(true);
    };

    const handleDeleteIconClick = (event: React.MouseEvent<HTMLElement>) => {
        deleteClip(groupClip.id);
        setOpenPopper(false);

    }

    const doubleClickOnCard = () => {
        addGroupClip(groupClip.id)
    }


    const handleMouseLeave = () => {
        if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
            hoverTimeoutRef.current = null;
        }
        setIsVideoPlaying(false);
        if (videoRef.current) {
            videoRef.current.pause();
            videoRef.current.currentTime = 0;
        }
    };

    function closeEditor() {
        setEditorOpen(false);
    }

    function onEditClick(clip: any) {
        if (clip.editorClip) {
            setEditorClip(clip.editorClip)
            setEditorOpen(true);
        } else if (clip) {
            const tempEditorClip = JSON.parse(JSON.stringify(clip))
            tempEditorClip.id = clip.groupId
            tempEditorClip.src = clip.original_clip_url
            setEditorClip(tempEditorClip)
            setEditorOpen(true);
        }else {
            setEditorError({error: true, message: 'The clip is corrupted and cannot be edited'});
        }

    }

    function onChangeCustomRating(isCustomRatingLoading: boolean) {
        setUpdateLoading(isCustomRatingLoading)
    }

    function onShareButtonClick() {
        if(groupClip.videoContentType === 'socialClip' && originalVideoContent){
            setPublishClip(originalVideoContent)
            setPublishOpen(true);
        }
    }

    function onPublishPopClose(){
        setPublishOpen(false);
    }

    return (
        <Box>
            <React.Fragment>
                <Card
                    onDoubleClick={doubleClickOnCard}
                    sx={{
                        width: "100%",
                        height: isFootball ? (isDraggable ? "400px" : "555px") : (isDraggable ? "450px" : "600px"),
                        position: "relative",
                        cursor: "pointer",
                        transition: "filter 0.3s ease",
                        backgroundColor: theme.palette.blue,
                        color: theme.palette.white,
                        border: isChecked ? `${theme.border.width.medium} solid ${theme.palette.orange}` : `${theme.border.width.thin} solid white`,
                        display: 'flex',
                        flexDirection: 'column',
                        borderRadius: theme.border.radius.md
                    }}

                >
                    <Box
                        sx={{width: "100%", flexShrink: 0}}
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                    >


                        {isVideoPlaying ? (
                            <AspectRatioBox>
                                <video
                                    ref={videoRef}
                                    src={groupClip.social_clip_url ? groupClip.social_clip_url : groupClip.url}
                                    muted
                                    preload="auto"
                                    poster={groupClip.thumbnail ? groupClip.thumbnail : logo}
                                    onCanPlay={() => videoRef.current?.play()}
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'contain',
                                        backgroundColor: `${theme.palette.blue}`
                                    }}
                                />
                            </AspectRatioBox>
                        ) : (
                            <CardMedia>
                                <Box position={'relative'} padding={groupClip.thumbnail === null ? theme.spacing.md : undefined}>
                                    <img width={'100%'} height={'auto'} alt="Thumbnail" src={groupClip.thumbnail ? groupClip.thumbnail : logo}/>
                                    {groupClip.highlight_type && groupClip.highlight_type !== 'Regular' && <Box padding={theme.spacing.xs} position={"absolute"} top={0} left={0}>
                                        <HighlightType highlight_type={groupClip.highlight_type}/>
                                    </Box>}
                                    {groupClip.editing &&
                                        <Box sx={{position: 'absolute', bottom: '10px', right: '5px'}}>
                                            <LoadingChip label={'Processing'} color={theme.palette.orange} pulse={true}/>
                                        </Box>
                                    }
                                    {groupClip.inbrief_tags && (groupClip.inbrief_tags.includes('fast') || groupClip.inbrief_tags.includes('Fast')) && <Box padding={theme.spacing.xs} position={"absolute"} top={0} left={0}>
                                        <HighlightType highlight_type={'Fast'}/>
                                    </Box>}
                                    {(groupClip.inbrief_tags && groupClip.inbrief_tags.includes('manual') && !groupClip.inbrief_tags?.includes("superadmin")) && <Box padding={theme.spacing.xs} position={"absolute"} top={0} left={0}>
                                        <HighlightType highlight_type={'Manual'}/>
                                    </Box>}
                                </Box>
                            </CardMedia>
                        )}

                        {(isDraggable && mode !== 'template' ) && (
                            <IconButton
                                sx={{
                                    position: "absolute",
                                    top: 4,
                                    right: 4,
                                    "&:hover": {backgroundColor: theme.palette.blue},
                                }}
                                onClick={(event) => {
                                    event.stopPropagation(); // Blocca la propagazione
                                    deleteClipDraggable?.(groupClip.id);
                                }}
                                onPointerDown={(event) => {
                                    event.stopPropagation(); // Evita il drag quando si clicca sull'icona
                                }}
                            >
                                <ClearIcon sx={{color: theme.palette.white}}/>
                            </IconButton>
                        )}

                        { (mode === "template") && (
                            <Box
                                sx={{
                                    position: "absolute",
                                    top: 4,
                                    left: 4,
                                }}

                                onPointerDown={(event) => {
                                    event.stopPropagation(); // Evita il drag quando si clicca sull'icona
                                }}
                            >

                                <StyledCheckBox  checked={!!idClipSelectedTemplate} onChange={(event)=>{
                                    if (handleCheckTemplate) {
                                        handleCheckTemplate(groupClip.id)
                                    }}}/>

                            </Box>
                        )}

                    </Box>
                    <CardContent
                        sx={{
                            padding: `${theme.spacing.sm}`,
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            overflowY: 'auto',
                            '&:last-child': {
                                paddingBottom: `${theme.spacing.sm}`,
                            }
                        }}>

                        {Object.keys(groupClip).map((key) => {


                            if (isDraggable === undefined) {
                                if (!visibleFieldGroupClip.includes(key)) return null;
                            } else {
                                if (!visibleFieldForDragAndDrop.includes(key)) return null;
                            }

                            const value = groupClip[key as keyof ClipGroup];

                            // Skip rendering if the value is undefined or null
                            if (value === undefined || value === null) return null;


                            return value ? (
                                <Box
                                    key={key}
                                    sx={{display: "flex"}}
                                >
                                    <Box>
                                        <Typography sx={{fontSize: theme.fontSizes.description, textAlign: "justify"}}>
                                            {formatLabel(key === "key_moment_type" ? "type" : key === "extraction_schedule" ? "scheduled_at" : key)}:&nbsp;
                                        </Typography>
                                    </Box>

                                    <Typography
                                        variant="h6"
                                        sx={{
                                            fontSize: theme.fontSizes.description,
                                            fontWeight: theme.fontWeights.value,
                                        }}
                                    >
                                        {value === "N/D" ? value : (key === 'match_date' || key === 'extraction_schedule' || key === 'created_at' || key === 'generated_at') ? formatUTCDate(value) : value}
                                    </Typography>
                                </Box>
                            ) : null;
                        })}

                        { (groupClip.type === 'clip' ) &&
                            (
                                <Box display={'flex'} alignItems={'center'}>
                                    <Typography sx={{fontSize: theme.fontSizes.description, textAlign: "justify"}}>
                                        {formatLabel("Generated at")}:&nbsp;
                                    </Typography>
                                    <Typography
                                        variant="h6"
                                        sx={{
                                            fontSize: theme.fontSizes.description,
                                            fontWeight: theme.fontWeights.value,
                                        }}
                                    >
                                        {formatUTCDate(groupClip.generate_at) }
                                    </Typography>
                                </Box>
                            )
                        }

                        {groupClip.type !== "clip" && groupClip.auto_rating !== undefined && (
                            <Box display={'flex'} alignItems={'center'}>
                                <Typography sx={{fontSize: theme.fontSizes.description, textAlign: "justify"}}>
                                    {formatLabel("rating")}:&nbsp;
                                </Typography>
                                <CustomRating auto_rating={groupClip.auto_rating} manual_rating={groupClip.manual_rating}
                                              clipId={groupClip.id} onChangeCustomRating={onChangeCustomRating}/>
                            </Box>
                        )}

                        {viewTag && (
                            <VideoContentTags
                                tags={groupClip.tags ? groupClip.tags : []}
                                contentType={'clip'}
                                label={'Tags:'}
                                onTagSelected={(tags) => updateVideoContentTags(groupClip.id, groupClip.videoContentType, tags)}
                                labelStyle={{
                                    fontSize:theme.fontSizes.subParagraphText,
                                    fontWeight:theme.fontSizes.subParagraphText,
                                    color:theme.palette.lightGrey,
                                    marginRight: theme.spacing.xs
                                }}
                            />

                        )}


                        {!isDraggable && (
                            <Box sx={{display: "flex", flexDirection: "row", marginTop: 'auto'}}>
                                <IconButton size="small" onClick={() => {
                                    handlePlayButton(groupClip.social_clip_url ? groupClip.social_clip_url : groupClip.url);
                                }}>
                                    <PlayArrowIcon sx={{color: theme.palette.white}}/>
                                </IconButton>
                                {       (groupClip.videoContentType === 'clip' ||
                                        (groupClip.videoContentType === 'socialClip' && groupClip.type !== 'highlight') ||
                                        (groupClip.videoContentType === 'socialClip' && groupClip.type === 'highlight' && groupClip.aspect_ratio === '16:9')) &&
                                    <IconButton size="small" onClick={() => {
                                    onEditClick(groupClip)
                                }}>
                                    <EditIcon sx={{color: theme.palette.white}}/>
                                </IconButton>}
                                <IconButton size="small" onClick={doubleClickOnCard}>
                                    <AddIcon sx={{color: theme.palette.white}}/>
                                </IconButton>
                                {groupClip.videoContentType === 'socialClip' && groupClip.aspect_ratio && <IconButton size="small" onClick={onShareButtonClick}>
                                    <ShareIcon sx={{color: theme.palette.white}}/>
                                </IconButton>}
                                <IconButton size="small" onClick={(e) => {
                                    if (!groupClip.type) {
                                        e.preventDefault();
                                        setOpenPopper(true);
                                        setAnchorEl(e.currentTarget);
                                    } else {
                                        handleDeleteIconClick(e)
                                    }
                                }}>
                                    <DeleteIcon sx={{color: theme.palette.white}}/>
                                </IconButton>
                            </Box>
                        )}
                    </CardContent>
                </Card>


                <Popper open={openPopper} anchorEl={anchorEl} placement="bottom-end">
                    <Paper sx={{p: 2}}>
                        <Typography>Are you sure that you want to delete all clips?</Typography>
                        <Box sx={{display: "flex", justifyContent: "flex-end", mt: 1}}>
                            <Button
                                variant="text"
                                onClick={handleDeleteIconClick}
                                sx={{mr: 1}}
                            >
                                Yes
                            </Button>
                            <Button variant="text" onClick={() => setOpenPopper(false)}>
                                No
                            </Button>
                        </Box>
                    </Paper>
                </Popper>


                <EditorPopup setExternalError={setEditorError} clip={(editorClip as any)} isOpen={editorOpen} handleClose={closeEditor}
                             setIsClipDownloading={setIsClipDownloading}/>
                {publishClip && <SocialPublishPopup clip={publishClip} socialClip={groupClip as SocialClip} isOpen={publishOpen} onClose={onPublishPopClose}/>}
                <StyledSnackbar
                    open={isClipDownloading === 'DOWNLOAD'}
                    setClose={() => setIsClipDownloading('NODOWNLOAD')}
                    message={'Wait for your download'}
                    severity={'info'}
                    closeButton={true}
                />
                <StyledSnackbar
                    open={isClipDownloading === 'FAILED'}
                    setClose={() => setIsClipDownloading('NODOWNLOAD')}
                    message={'Error to download your clip'}
                    severity={'error'}
                    closeButton={true}
                />

                <ErrorSnackBar autoHideDuration={10000} open={editorError.error}
                               setClose={() => setEditorError({message: '', error: false})}
                               errorMessage={editorError.message}/>


            </React.Fragment>


        </Box>

    )
}

export default CardClipComponent